<template>
  <div class="thumb portrait">
    <a
      href="javascript:void(0)"
      :aria-label="altTitle"
      role="button"
      @click.prevent="$emit('on-click')"
    >
      <div class="thumb-image">
        <div
          class="no-thumb"
          :aria-hidden="!isImageLoaded"
          :style="`display: ${displayCss}`"
        >
          <span class="alt-text">{{ alt }}</span>
        </div>
        <ul class="badge-list">
          <li class="left-top-area">
            <ul v-top-tag-list="topTagList"></ul>
          </li>
          <li
            v-common-tag-list="{ badgeList: brandTagList, type: 'brand' }"
            class="right-top-area"
          ></li>
        </ul>
        <div v-if="hasProgress" class="cell-progress">
          <span
            class="gradation-purple"
            :style="'width:' + Number(progress) * 100 + '%;'"
          ></span>
        </div>
        <div class="picture-area">
          <WebpImage
            :image-info="{
              imageUrl: cellInfo.thumbnail,
              width: thumbnailInfo.width,
              height: thumbnailInfo.height,
              alt: altTitle,
              className: 'thumb-img',
              onImageLoad,
            }"
          />
        </div>
        <age-limits :target-age="targetAge" :age-tag="ageTag" />
        <div :class="adultDimClass"></div>
        <div v-if="isPlayCta" class="play_now">
          <span class="a11y-hidden">시청하기</span>
        </div>
      </div>
      <div :class="subTitleClass" aria-hidden="true">
        <div v-if="hasRank" class="sub-left">
          <div class="num">{{ rank }}</div>
        </div>
        <div
          v-title-list="{
            titleList: titleList,
            cellType: 'portrait',
            callback: loaded,
          }"
          class="sub-right"
        >
          >
        </div>
      </div>
    </a>
  </div>
</template>

<script>
  import _ from 'lodash'
  import AgeLimits from '@/components/model/AgeLimits'
  import {
    titleList,
    topTagList,
    commonTagList,
  } from '@/common/resources/directives'
  import CellMixIn from '@/mixins/cell.mixin'
  import shave from 'shave'
  import WebpImage from '@/components/image/WebpImage'
  export default {
    name: 'PortraitCell',
    directives: {
      titleList,
      topTagList,
      commonTagList,
    },
    components: {
      WebpImage,
      AgeLimits,
    },
    mixins: [CellMixIn],
    props: {
      cellInfo: {
        type: Object,
      },
      thumbnailInfo: {
        type: Object,
      },
    },
    methods: {
      loaded(el) {
        this.$nextTick(() => {
          _.forEach(el.querySelectorAll('.line1'), (line1El) => {
            shave(line1El, 28)
          })
        })
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/import/portrait.scss"></style>
